let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j9u4n")).then(() => parcelRequire('8WXuv'));